export default {"src":"https://cp-landing.wukongedu.net/_next/static/media/logo.9aedef69.svg","height":273,"width":815,"blurWidth":0,"blurHeight":0};